import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Safe } from '../../types/safes.types';
import { useAppQuery } from '../use-app-query.hook';

export const useSafe = ({
  companyId,
  safeId,
  enabled = true,
}: {
  companyId: string;
  enabled?: boolean;
  safeId: string;
}) => {
  const queryClient = useQueryClient();

  const { data: safe, isLoading } = useAppQuery<Safe>({
    queryKey: [QueryKey.GET_SAFE, companyId, safeId],
    queryFn: () =>
      ApiService.get({ endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'safes', safeId] }),
    enabled: !!companyId && !!safeId && enabled,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SAFE] });
  }, [queryClient]);

  return {
    invalidateQuery,
    safe,
    isLoading,
  };
};
